import { TranslatedText } from '../Translation';

export interface Meta {
  title?: string;
  titleTranslation: TranslatedText;
  description?: string;
  descriptionTranslation: TranslatedText;
  canonicalURL?: string;
}

export const getEmptyMeta = (): Meta => ({
  titleTranslation: {},
  descriptionTranslation: {},
});

export const metaFromResponse = (responseData: any): Meta => ({
  title: responseData.title,
  titleTranslation: responseData.title_translation ?? {},
  description: responseData.description,
  descriptionTranslation: responseData.description_translation ?? {},
  canonicalURL: responseData.canonical_url,
});

export const metaToUpsertRequest = (meta: Meta) => ({
  title: meta.title,
  title_translation: meta.titleTranslation,
  description: meta.description,
  description_translation: meta.descriptionTranslation,
  canonical_url: meta.canonicalURL,
});
